import { render, staticRenderFns } from "./DependantForm.vue?vue&type=template&id=75623748"
import script from "./DependantForm.vue?vue&type=script&lang=js"
export * from "./DependantForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports